import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  addItemToCart,
  athGetAllCartsRoute,
  deleteCart,
  getCartByUser,
} from '../../utils/apiRoutes';

export const getAllCartAsync = createAsyncThunk(
  `${moduleName}/getAllCartAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: athGetAllCartsRoute(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const addItemToCartAsync = createAsyncThunk(
  `${moduleName}/addItemToCartAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'POST',
      url: addItemToCart(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const getCartByUserAsync = createAsyncThunk(
  `${moduleName}/getCartByUserAsync`,
  async (id) => {
    const response = await axiosAtheneum({
      method: 'GET',
      url: getCartByUser(id),
    });
    const data = response.data;
    return data;
  }
);

export const deleteCartAsync = createAsyncThunk(
  `${moduleName}/deleteCartAsync`,
  async (id) => {
    const response = await axiosAtheneum({
      method: 'DELETE',
      url: deleteCart(id),
    });
    const data = response.data;
    return data;
  }
);

const cartSlice = createSlice({
  name: `${moduleName}/Cart`,
  initialState: {
    loading: false,
    cart: [],
    userCart: null,
  },
  reducers: {},
  extraReducers: {
    [getAllCartAsync.pending]: (state) => {
      state.loading = true;
    },
    [getAllCartAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.cart = action.payload.data;
    },
    [getAllCartAsync.rejected]: (state) => {
      state.loading = false;
    },

    [getCartByUserAsync.pending]: (state) => {
      state.loading = true;
    },
    [getCartByUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.userCart = action.payload[0];
    },
    [getCartByUserAsync.rejected]: (state) => {
      state.loading = false;
    },

    [getCartByUserAsync.pending]: (state) => {
      state.loading = true;
    },
    [getCartByUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.userCart = action.payload;
    },
    [getCartByUserAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default cartSlice.reducer;
